import React from "react";
import Cookies from "js-cookie";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useState, useEffect } from "react";
import { IoIosArrowDown, IoIosArrowForward, IoIosArrowUp, IoIosMale, IoIosFemale } from "react-icons/io";
import { Button } from "react-bootstrap";

import { PALETTE } from "../../common/ThemeConstants";
import {
  getRequest,
  deleteRequest,
  postRequest,
} from "../../api/axiosRequests";
import AlertModal from "../../common/components/AlertModal";
import CardAdminPlanWeek from "./CardAdminPlanWeek";

export default function CardAdminPlan({ plan, height = 100, editCallback }) {
  const [isSelected, setIsSelected] = useState(false);
  const [planWeeks, setPlanWeeks] = useState([]);
  const [currentPlanWeek, setCurrentPlanWeek] = useState({ id: -1 });
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const SexComponent = plan.sex === "M" ?
    (<span className="rounded-sm px-2 py-1" style={{ background: PALETTE.MAINCOLORLIGHT, fontSize: 12 }}><IoIosMale style={{ marginBottom: 3 }} /> <span>Maschio</span></span>) :
    plan.sex === "F" ?
      (<span className="rounded-sm px-2 py-1" style={{ background: PALETTE.SECONDARYCOLORLIGHT, fontSize: 12 }}><IoIosFemale style={{ marginBottom: 3 }} /> <span>Femmina</span></span>) :
      (<span className="rounded-sm px-2 py-1" style={{ background: PALETTE.GRADIENTLIGHT, fontSize: 12 }}><IoIosMale style={{ marginBottom: 3 }} /> <IoIosFemale style={{ marginBottom: 3 }} /><span>Maschio/Femmina</span></span>);

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise = getRequest("planWeekList/", headers)
    promise.then((res) => {
      const planWeekData = res["data"];
      const filteredPlanWeeks = planWeekData
        .filter((el) => el.plan === plan.id)
        .sort((a, b) => (a.position > b.position ? 1 : -1));
      setPlanWeeks(filteredPlanWeeks);
    })
      .catch((errs) => { });
  }

  const resetCurrentPlanWeek = () => {
    setCurrentPlanWeek({ id: -1 });
  };

  const onAddPlanWeekButtonClicked = () => {
    resetCurrentPlanWeek();
    let formData = new FormData();
    formData.append("id", -1);
    formData.append("plan", plan.id);
    formData.append("position", getNextPlanWeekPosition());
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrftoken,
    };
    postRequest("planWeek/", formData, headers)
      .then((res) => {
        fetchData();
      })
      .catch((errs) => { });
  };

  const onDeletePlanWeekButtonClicked = (id) => {
    const planWeek = planWeeks.filter((p) => p.id === id)[0];
    setCurrentPlanWeek(planWeek);
    setShowDeleteForm(true);
  };

  function getNextPlanWeekPosition() {
    if (planWeeks.length == 0) {
      return 0;
    }
    return planWeeks.at(-1).position + 1;
  }

  async function deleteCallback(id) {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const response = await deleteRequest("planWeek/" + id, headers);
    setShowDeleteForm(false);
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AlertModal
        show={showDeleteForm}
        getDataId={() => {
          return currentPlanWeek.id;
        }}
        onHide={() => {
          setShowDeleteForm(false);
        }}
        onCancel={() => {
          setShowDeleteForm(false);
        }}
        onConfirm={(id) => {
          deleteCallback(id);
        }}
        title={"Delete workout week"}
        description={
          "Are you sure you want to delete the workout week? Also the associated protocols will be deleted"
        }
      />
      <div
        className="my-2 shadow-sm rounded-md"
        style={{ border: "solid 0px", backgroundColor: PALETTE.WHITE }}
      >
        <Row
          className="g-0 align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            editCallback(plan.id);
          }}
        >
          <Col xs={3} className="align-self-center text-start p-1">
            <img
              className="rounded-md"
              style={{
                objectFit: "cover",
                height: height,
                width: height,
                maxWidth: "100%",
              }}
              src={plan.cover}
              alt={plan.name}
            />
          </Col>
          <Col xs={7} className="text-start" style={{ paddingLeft: "4px" }}>
            <p className="cardDescription" style={{ marginBottom: "2px" }}>
              {plan.name}
            </p>
            <p style={{ marginBottom: "4px" }}>
              {SexComponent}
              <span
                className="mx-1"
                style={{ color: PALETTE.DARK, width: "fit-content", fontWeight: "bold" }}
              >
                {plan.price} €
              </span>
            </p>

            <span className="px-2 py-1 rounded-sm" style={{ background: PALETTE.LIGHTGRAY, fontSize: 12 }}>
              {`Livello ${plan.level}`}
            </span>
            <span className="px-2 py-1 rounded-sm mx-1" style={{ background: PALETTE.LIGHTGRAY, fontSize: 12 }}>
              {`Settimane ${plan.weeks}`}
            </span>
          </Col>
          <Col xs={2} className="align-self-center text-end px-2">
            <IoIosArrowForward size={25} color={PALETTE.GRAY} />
          </Col>
        </Row>
        {isSelected && (
          <Row>
            <div className="d-grid gap-2">
              {planWeeks.map((planWeek, idx) => (
                <div key={idx}>
                  <CardAdminPlanWeek
                    planWeek={planWeek}
                    onDeleteButtonClicked={() => {
                      onDeletePlanWeekButtonClicked(planWeek.id);
                    }}
                  />
                </div>
              ))}
              <Button
                className="rounded py-3 mx-2 my-1"
                style={{
                  backgroundColor: PALETTE.KINDALIGHTGRAY,
                  color: PALETTE.DARK,
                  border: "0",
                }}
                onClick={onAddPlanWeekButtonClicked}
              >
                Add workout week
              </Button>
            </div>
          </Row>
        )}
        <Row
          className="py-1 mt-1 g-0 rounded-md-bottom"
          style={{ cursor: "pointer", backgroundColor: PALETTE.LIGHTGRAY }}
          onClick={() => setIsSelected(!isSelected)}
        >
          <Col className="align-self-center text-center">
            {isSelected && <IoIosArrowUp size={25} color={PALETTE.GRAY} />}
            {!isSelected && <IoIosArrowDown size={25} color={PALETTE.GRAY} />}
          </Col>
        </Row>
      </div>
    </>
  );
}
